import React from "react";
import {
  Box,
  Chip,
  Typography,
  Tooltip,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import WarningIcon from '@mui/icons-material/Warning';

interface Hotel {
  id: number;
  name: string;
  hasData: boolean;
  warning?: boolean;
}

interface HotelDataStatusListProps {
  hotels: Hotel[];
  title?: string;
}

const HotelDataStatusList: React.FC<HotelDataStatusListProps> = ({
  hotels,
  title = "Statut des données",
}) => {
  if (hotels.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        width: "95%",
        mb: 2,
        display: "flex",
        alignItems: "center",
        gap: 2,
        flexWrap: "wrap",
        justifyContent: "center",
      }}
    >
      {hotels.map((hotel) => (
          <Tooltip
            key={hotel.id}
            title={
              hotel.hasData
                ? (hotel.warning ? "Une ou plusieurs données sont égales à 0" : "Données disponibles pour cette période")
                : "Aucune donnée pour cette période"
            }
            arrow
          >
            <Chip
              label={hotel.name}
              icon={
                hotel.hasData ? (
                  hotel.warning ? (
                    <WarningIcon />
                  )
                  : (
                    <CheckCircleIcon />
                  )
                ) : (
                  <CancelIcon />
                )
              }
              sx={{
                backgroundColor: hotel.hasData ? (hotel.warning ? "#fff8e1" : "#e8f5e9") : "#ffebee",
                color: hotel.hasData ? (hotel.warning ? "#f9a825"  : "#2e7d32") : "#c62828",
                fontWeight: 500,
                "& .MuiChip-icon": {
                  color: hotel.hasData ? (hotel.warning ? "#d4c706ff" : "#4caf50") : "#ef5350",
                },
                "&:hover": {
                  backgroundColor: hotel.hasData ? (hotel.warning ? "#ffe082" : "#c8e6c9") : "#ffcdd2",
                },
              }}
            />
          </Tooltip>
        ))}
    </Box>
  );
};

export default HotelDataStatusList;
